import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, roles = [], permiso = null }) => {
  const { user, loading, isAuthenticated, hasPermiso } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white">
        <Loader2 className="w-12 h-12 text-red-700 animate-spin mb-4" />
        <p className="text-xs font-black uppercase tracking-[0.2em] text-gray-400">Verificando sesión segura...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !roles.includes(user.rol)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (permiso && !hasPermiso(permiso)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
